export enum OverviewModesEnum {
  TRANSACTIONS = 'TRANSACTIONS',
  CASHCUTS = 'CASHCUTS',
}
